import { customerAllowedCheck } from '../custom';
import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger } from '../utils';

export const checkoutLoadedConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.CHECKOUT_LOADED,
  handler: async ({ detail }) => {
    logger('Checkout Loaded');
    console.log(detail);
    // allows for alternative handling of shipping selection in the checkout itself
    await customerAllowedCheck(detail.customer);
  },
};
